import './MobileWarning.css';

const MobileWarning = (): React.ReactElement => {
  return (
    <div className="mobileWarning">
      <h2>VR Art Gallery</h2>
      <p>
        Please visit gallery.nxdec.io in the Meta Quest browser or use a web browser on a desktop, connect your headset
        and press Enter VR.
      </p>
    </div>
  );
};
export default MobileWarning;
